<template>
  <rounded-card
    show-right-btn
    close-on-overlay
    height="auto"
    :head-text="$t('result.oops')"
    @set-close-status="$emit('close')"
  >
    <div class="error-sheet w-full flex flex-col items-center text-center">
      <p class="error-sheet-text" v-html="text"></p>
      <img class="error-sheet-illustration" :src="illustration" alt="" />
      <c-button v-if="action" class="error-sheet-action" @click="$emit('action')">
        <span>{{ action.label }}</span>
      </c-button>
    </div>
  </rounded-card>
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import RoundedCard from '@/components/common/RoundedCard.vue';
import CButton from '@/components/common/CButton.vue';
import forbidden from '@/assets/Error/oops/forbidden.svg';
import network from '@/assets/Error/oops/network.svg';
import bluetooth from '@/assets/Error/oops/bluetooth.svg';
import device from '@/assets/MobileScan/unsupported-device.svg';
import forbiddenSanne from '@/assets/sanne/oops-forbidden.svg';
import networkSanne from '@/assets/sanne/oops-network.svg';
import bluetoothSanne from '@/assets/sanne/oops-bluetooth.svg';
import deviceSanne from '@/assets/sanne/oops-device.svg';

// [default brand, Sanne] per kind. The Sanne files are the same line art with
// #262626 swapped for #453128, which is also how the Figma Sanne file does it.
const ILLUSTRATIONS = {
  forbidden: [forbidden, forbiddenSanne],
  network: [network, networkSanne],
  bluetooth: [bluetooth, bluetoothSanne],
  device: [device, deviceSanne],
};

/**
 * The app-wide error sheet behind `$events.alert(text, { kind, action })`.
 * Figma: Cloudzet-App-Mobile-Scan / Error section (3279:11082) for the default
 * brand, Template-Cloudzet-App-Sanne / Error section for Sanne; the two differ
 * only by the brand tokens and the illustration colour. RoundedCard gives it the
 * bottom sheet on phones and the 496 centred card on Sanne iPad.
 */
export default {
  name: 'ErrorSheet',
  mixins: [brandMode],
  components: {
    RoundedCard,
    CButton,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    kind: {
      type: String,
      default: 'forbidden',
      validator: value => value in ILLUSTRATIONS,
    },
    // { label, event }: a primary button; App.vue emits `event` on the bus
    action: {
      type: Object,
      default: null,
    },
  },
  computed: {
    illustration() {
      const [defaultAsset, sanneAsset] = ILLUSTRATIONS[this.kind] || ILLUSTRATIONS.forbidden;
      return this.brandAsset(defaultAsset, sanneAsset);
    },
  },
};
</script>

<style lang="scss" scoped>
.error-sheet {
  // Figma error sheets: padding 24 / 28 / 60 with the blocks 32 apart. The
  // title row (and its 32 below) comes from RoundedCard.
  padding: 0 28px calc(60px + env(safe-area-inset-bottom));
  color: var(--color-text);
}
.error-sheet-text {
  @apply text-sm font-semibold;
  max-width: 280px;
  line-height: 1.5;
}
.error-sheet-illustration {
  width: 160px;
  height: 160px;
  margin-top: 32px;
  object-fit: contain;
}
.error-sheet-action {
  margin-top: 32px;
}
</style>
